import React from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import RangeShootingReasonForm from '../../../components/forms/RangeShootingReasonForm';
import { useCreateRangeShootingReason } from '../../../hooks/useRangeShootingReasonApi';
import { useNavigate } from 'react-router-dom';
import { RangeShootingReasonDTO } from '../../../services/apiClient';

const RangeShootingReasonCreate: React.FC = () => {
  const createMutation = useCreateRangeShootingReason();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Range Shooting Reasons', href: '/admin/rangeshootingreasons' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: RangeShootingReasonDTO) => {
    try {
      await createMutation.mutateAsync(data);
      navigate('/admin/rangeshootingreasons');
    } catch (error) {
      console.error('Error creating RangeShootingReason:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/rangeshootingreasons"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.RangeShootingReason.Edit'
    >
        <RangeShootingReasonForm
          initialValues={{} as RangeShootingReasonDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/rangeshootingreasons')}
        />
    </AdminLayout>
  );
};

export default RangeShootingReasonCreate;